// src/store/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../../utils/agent";
import * as API from "../../../../utils/apiPath";

// Async Thunks
export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (params, { rejectWithValue }) => {
    try {
      const res = await agent.post(API.LOGIN, params);
      return res;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const sendEmailForVerification = createAsyncThunk(
  "auth/sendEmailForVerification",
  async (params, { rejectWithValue }) => {
    try {
      const res = await agent.post(API.SEND_EMAIL_FOR_VERIFICATION, params);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const loadSettings = createAsyncThunk(
  "auth/loadSettings",
  async (_, { rejectWithValue }) => {
    try {
      const res = await agent.get(API.SETTING);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const signInSlice = createSlice({
  name: "signIn",
  initialState: {
    userInfo: null,
    setting: null,
    loading: false,
    popupMessage: "",
    showPopup: false,
  },
  reducers: {
    clearPopup(state) {
      state.showPopup = false;
      state.popupMessage = "";
    },
    logout(state) {
      state.userInfo = null;
    },
    setUserFromSSO(state, action) {
      state.userInfo = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Login
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload?.status === 200) {
          state.userInfo = action.payload.data;
        }
        state.popupMessage = action.payload.message || "Login successful";
        state.showPopup = true;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.popupMessage = action.payload?.message || "Login failed";
        state.showPopup = true;
      })

      // Send Email Verification
      .addCase(sendEmailForVerification.pending, (state) => {
        state.loading = true;
      })
      .addCase(sendEmailForVerification.fulfilled, (state, action) => {
        state.loading = false;
        state.popupMessage = action.payload.message || "Verification email sent";
        state.showPopup = true;
      })
      .addCase(sendEmailForVerification.rejected, (state, action) => {
        state.loading = false;
        state.popupMessage = action.payload?.message || "Failed to send email";
        state.showPopup = true;
      })

      // Load Settings
      .addCase(loadSettings.fulfilled, (state, action) => {
        state.setting = action.payload.data;
      });
  },
});

export const { clearPopup, logout, setUserFromSSO } = signInSlice.actions;
export default signInSlice.reducer;